import { uploadImageMedia } from '../../../apis/TemplateAPI';
import { useState } from 'react';
import Config from '../../../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from "universal-cookie";
import { useParams } from "react-router-dom";

const cookies = new Cookies();

const Sidebar = ({ imageMedia, setImageMedia, currentImage, setCurrentImage, createImage, setBackgroundImage, orientation, setOrientation,
                    createCertNo, setCertPrefix, activeStatus, setActiveStatus }) => {

    toast.configure();
    const {clientId} = useParams();
    const [imageData, setImageData] = useState();
    const [selImage, setSelImage] = useState();
    const [imageUploaded, setImageUploaded] = useState();

    const [showUploadModal, setShowUploadModal] = useState(false);

    const token = cookies.get("token");

    const readFile = (e) => {
        var file = e.target.files[0];
    let fileUpload_flag = false;

      if (
        file.type == "image/jpeg" ||
        file.type == "image/jpg" ||
        file.type == "image/png"
      )  {
        var img = new Image();
        img.onload = function () {
          fileUpload_flag = true;
          URL.revokeObjectURL(img.src);
        };
        img.src = URL.createObjectURL(file);
      }

    setTimeout(() => {
      if (fileUpload_flag === true) {
        setImageData(file);
        setSelImage(URL.createObjectURL(file));
      } else {
        setImageData(null);
        setSelImage("");
      }
    }, 200);
    }

    const uploadImage = () => {
        uploadImageMedia(token, clientId, "image", imageData)
            .then(response => {
                let imgMedia = imageMedia;
                setImageMedia([...imgMedia.concat({id: null, mediaUrl: response?.data?.media_path, type: "image"})])
                setImageUploaded(true);
                setShowUploadModal(false);
                setImageData(null);
                toast.success("Image uploaded successfully!", {
                    position: 'top-left',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: false
                  })
            })
            .catch(err => {
                toast.error("Error occured while uploading image.", {
                    position: 'top-left',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: false
                  })
                  setShowUploadModal(false);
            })
    }

    return (
        <section className="sidebar">
            <label className="px-3 mt-2 text-black mb-0">Canvas Orientation:</label>
            <section className="d-flex px-3 mb-2">
                <div className="form-check d-flex align-items-center">
                    <input className="form-check-input py-0" type="radio" name="exampleRadios" id="exampleRadios1" value="landscape" 
                    onClick={(e) => setOrientation(e.target.value)} checked={ orientation === "landscape" }/>
                    <label class="form-check-label text-black" for="exampleRadios1">
                        <small>Landscape</small>
                    </label>
                </div>
                <div className="ml-4 form-check d-flex align-items-center">
                    <input className="form-check-input py-0" type="radio" name="exampleRadios" id="exampleRadios2" value="portrait" 
                    onClick={(e) => setOrientation(e.target.value)} checked={ orientation === "portrait" }/>
                    <label className="form-check-label text-black" for="exampleRadios2">
                        <small>Portrait</small>
                    </label>
                </div>
            </section>
            <label className="px-3 mt-2 text-black mb-0">Active Status:</label>
            <section className="d-flex px-3 mb-3">
                <div className="form-check d-flex align-items-center">
                    <input className="form-check-input py-0" type="radio" name="activeStatusRadios" id="activeStatusRadios1" value={1} 
                    onClick={(e) => setActiveStatus(e.target.value)} checked={ activeStatus == 1 }/>
                    <label class="form-check-label text-black" for="activeStatusRadios1">
                        <small>Active</small>
                    </label>
                </div>
                <div className="ml-4 form-check d-flex align-items-center">
                    <input className="form-check-input py-0" type="radio" name="activeStatusRadios" id="activeStatusRadios2" value={3} 
                    onClick={(e) => setActiveStatus(e.target.value)} checked={ activeStatus == 3}/>
                    <label className="form-check-label text-black" for="activeStatusRadios2">
                        <small>Inactive</small>
                    </label>
                </div>
            </section>
            <div className="d-flex mb-4 px-3 align-items-center">
                {/* <label className="text-black"><small>Certificate <br/>no. prefix:</small></label>
                <input className="w-25 form-control form-control-sm ml-3" type="text" onChange={ (e) => { setCertPrefix(e.target.value) } }></input>
                <button className="ml-3 px-1 btn-sm btn-light border border-dark" onClick={ createCertNo }>Add</button>   */}
                <button className="px-1 btn-sm btn-light border border-dark" onClick={ createCertNo }>Add Certificate No.</button>  
            </div>
            <div className="row m-2">
                <button className="btn btn-sm btn-light border border-dark w-100 py-1" onClick={() => setShowUploadModal(true)}><i class="bi bi-upload mr-1"></i> Upload Images</button>  <br/>
            </div>
            <div className="row">
                <div className="col">
                    <div class="img-list px-3">
                        {
                            imageMedia?.map(image => 
                                {
                                    if(image?.type === "image" || image?.type === "background") {
                                        return (
                                            <img className={"m-1" + (image?.mediaUrl === currentImage ? " selected-border" : "") } 
                                            src={image.mediaUrl} width="45%" 
                                            onClick={(e) => setCurrentImage(e.target.src) }/>
                                        )
                                    }
                                }
                            )
                        }
                    </div>

                    <button className="btn btn-sm py-1 btn-light border border-dark m-2 ml-4 w-75" onClick={ createImage }><i class="bi bi-image mr-2"></i>Add Image</button>
                    <div className="d-flex">
                    <button className="btn btn-sm py-1 btn-light border border-dark m-2" onClick={() => setBackgroundImage(true)}> <i class="bi bi-plus mr-1"></i> Set as background</button>
                    <button className="btn btn-sm py-1 btn-danger m-2" onClick={() => setBackgroundImage(false) }> <i class="bi bi-x mr-1"></i> Remove Background</button>
                    </div>
                </div>
            </div>

            {/* Modal to upload Images */}
            {
                showUploadModal ?
                <div id="image-upload-modal" className="modal d-flex overlay-bg">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Upload Image</h5>
                            <button type="button" class="close" aria-label="Close" onClick={() => setShowUploadModal(false)}></button>
                        </div>
                        <div class="modal-body">
                            <p>Select a file to upload. Formats supported: .jpg, .jpeg, .png</p>
                            <input className="form-control mb-3" type="file" onChange={e => readFile(e)}/>
                            {
                                imageUploaded ?
                                <p className="text-success">Image uploaded successfully</p>
                                :
                                null
                            }
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" onClick={() => setShowUploadModal(false)}>Cancel</button>
                            <button type="button" class="btn btn-light border border-dark" onClick={uploadImage}>Upload Image</button>
                        </div>
                    </div>
                </div>
            </div>
            : null
            }
        </section>
    )
}

export default Sidebar;